var _polygon, _polygon2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeoutImg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M373.23,244a21.78,21.78,0,0,1,2.12-5.37l-2.92-4.47,6.15-6.36,4.57,2.78a21.6,21.6,0,0,1,5.3-2.3l1.09-5.23,8.85-.15,1.27,5.2a21.78,21.78,0,0,1,5.37,2.12l4.47-2.93,6.36,6.16L413.08,238a21.53,21.53,0,0,1,2.3,5.29l5.23,1.1.15,8.85-5.2,1.27a21.87,21.87,0,0,1-2.12,5.36l2.93,4.48-6.16,6.36L405.64,268a21.91,21.91,0,0,1-5.29,2.3l-1.1,5.23-8.85.14-1.27-5.19a21.87,21.87,0,0,1-5.36-2.12l-4.48,2.92-6.36-6.15,2.78-4.57a22,22,0,0,1-2.3-5.3l-5.23-1.09-.14-8.85,5.19-1.27Zm11.67,5a9.49,9.49,0,1,0,9.34-9.65A9.48,9.48,0,0,0,384.9,249Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.9,249a7.24,7.24,0,0,1,.16-2.35,9.57,9.57,0,0,1,7.38-7.32,9.8,9.8,0,0,1,5.12.31,9.78,9.78,0,0,1,4.59,3.31,9.7,9.7,0,0,1,.19,11.52,9.05,9.05,0,0,1-2,2.1,9.19,9.19,0,0,1-2.44,1.36,9.75,9.75,0,0,1-5.11.48,9.6,9.6,0,0,1-7.62-7.08,7.32,7.32,0,0,1-.23-2.33,21.12,21.12,0,0,0,.43,2.28,9.5,9.5,0,0,0,3.55,5.05,9.28,9.28,0,0,0,8.8,1.15,8.88,8.88,0,0,0,2.32-1.3,8.7,8.7,0,0,0,1.92-2,9.22,9.22,0,0,0-.18-10.92,8.88,8.88,0,0,0-2-1.94,8.69,8.69,0,0,0-2.36-1.22,9.29,9.29,0,0,0-4.87-.34,9.12,9.12,0,0,0-3.89,1.77,9.45,9.45,0,0,0-3.38,5.17A19.37,19.37,0,0,0,384.9,249Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.23,244a1.31,1.31,0,0,1-.32.1l-1,.26-3.87,1,.06-.08c.05,2.26.11,5.24.19,8.84l-.1-.12,5.24,1.07.09,0,0,.09a21.81,21.81,0,0,0,2.3,5.25l.05.09-.05.08-2.77,4.58,0-.23,6.37,6.15-.25,0,4.47-2.93.11-.08.11.07a22.18,22.18,0,0,0,5.32,2.09l.13,0,0,.14c.4,1.61.83,3.38,1.28,5.19l-.23-.18,8.85-.15-.24.19c.34-1.63.72-3.42,1.09-5.24l0-.14.15,0a21.48,21.48,0,0,0,5.23-2.28l.13-.08.13.08,4.57,2.78-.31,0,6.15-6.36,0,.32-2.93-4.48-.08-.13.07-.14a21.33,21.33,0,0,0,2.1-5.29h0l0-.15.15,0,5.2-1.26-.2.25c-.05-3-.1-5.94-.14-8.85l.2.25-5.23-1.1-.15,0-.05-.15a21.38,21.38,0,0,0-2.26-5.23l-.08-.13.08-.13,2.78-4.57,0,.31-6.35-6.16.29,0-4.48,2.93-.12.07-.12-.07a21.53,21.53,0,0,0-5.3-2.1l-.14,0,0-.13-1.26-5.2.22.17-8.85.13.19-.16c-.39,1.84-.76,3.56-1.11,5.23l0,.11-.11,0a21.68,21.68,0,0,0-5.26,2.26l-.09.06-.09-.06L378.5,228l.19,0-6.18,6.34,0-.15,2.89,4.5,0,0,0,0a22.2,22.2,0,0,0-1.77,4c-.14.44-.24.78-.32,1s-.11.34-.11.34,0-.12.07-.35.14-.58.28-1a20.87,20.87,0,0,1,1.7-4v.09c-.8-1.22-1.77-2.68-2.95-4.46l-.05-.08.06-.06,6.13-6.39.09-.09.1.07,4.58,2.76h-.17a21.58,21.58,0,0,1,5.33-2.33l-.14.14c.35-1.66.71-3.39,1.09-5.23l0-.16h.16l8.85-.16h.17l0,.17c.42,1.69.84,3.41,1.28,5.19l-.17-.16a21.76,21.76,0,0,1,5.43,2.14h-.24l4.47-2.94.16-.1.14.13,6.37,6.15.14.14-.11.17-2.77,4.57v-.26a21.86,21.86,0,0,1,2.33,5.35l-.2-.18,5.24,1.1.2,0v.21q.08,4.37.15,8.84v.21l-.2.05-5.2,1.27.2-.19h0a22.28,22.28,0,0,1-2.14,5.43v-.27l2.92,4.48.12.17-.15.15-6.16,6.36-.14.14-.17-.1-4.57-2.79h.26a21.55,21.55,0,0,1-5.36,2.32l.18-.18c-.38,1.81-.76,3.6-1.1,5.23l0,.19h-.2l-8.85.14h-.18l0-.18-1.26-5.2.16.17a22.31,22.31,0,0,1-5.42-2.16h.23l-4.49,2.91-.13.09-.12-.11-6.35-6.17-.1-.1.07-.13,2.79-4.56v.17a21.94,21.94,0,0,1-2.29-5.34l.11.11-5.23-1.11-.1,0v-.1c0-3.61-.07-6.59-.1-8.85v-.07H368l3.86-.9,1-.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.41,219.61a24.61,24.61,0,0,1,2.37-6l-3.27-5,6.88-7.11,5.12,3.11a24.46,24.46,0,0,1,5.92-2.57l1.22-5.85,9.9-.16,1.42,5.81a24.21,24.21,0,0,1,6,2.37l5-3.27,7.11,6.88L159,212.93a24.29,24.29,0,0,1,2.57,5.92l5.85,1.22.16,9.9-5.81,1.42a24.21,24.21,0,0,1-2.37,6l3.27,5-6.88,7.11-5.12-3.11a24.29,24.29,0,0,1-5.92,2.57l-1.22,5.85-9.9.16-1.42-5.81a24.21,24.21,0,0,1-6-2.37l-5,3.27-7.11-6.88,3.11-5.12a24.46,24.46,0,0,1-2.57-5.92l-5.85-1.22-.16-9.9,5.81-1.42Zm13,5.61a10.62,10.62,0,1,0,10.44-10.79A10.62,10.62,0,0,0,127.46,225.22Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.47,194a7,7,0,0,1,.68-1.73l-.94-1.45,2-2.05,1.47.9a7.28,7.28,0,0,1,1.71-.75l.35-1.69,2.86,0,.41,1.67a7.27,7.27,0,0,1,1.73.69l1.45-.94,2.05,2-.89,1.48a7.25,7.25,0,0,1,.74,1.71l1.69.35,0,2.86-1.67.41a7.44,7.44,0,0,1-.69,1.73l.95,1.45-2,2-1.48-.9a6.86,6.86,0,0,1-1.71.74l-.35,1.69-2.86.05-.41-1.68a7,7,0,0,1-1.73-.68l-1.45.94-2.05-2,.9-1.48a6.86,6.86,0,0,1-.74-1.71l-1.69-.35,0-2.86,1.68-.41Zm3.76,1.62a3.07,3.07,0,1,0,3-3.12A3.07,3.07,0,0,0,346.23,195.66Z",
    style: {
      fill: "#e0e0e0",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.58,223.62a9.94,9.94,0,0,1,1-2.39l-1.31-2L51,216.38l2,1.24a9.36,9.36,0,0,1,2.36-1l.49-2.34,4-.07.57,2.32a10.37,10.37,0,0,1,2.39,1l2-1.3,2.84,2.75-1.24,2a9.81,9.81,0,0,1,1,2.37l2.34.49.07,3.95-2.33.57a10,10,0,0,1-.94,2.4l1.3,2-2.75,2.84-2-1.24a9.43,9.43,0,0,1-2.37,1l-.49,2.34-4,.07-.57-2.32a10,10,0,0,1-2.4-.95l-2,1.31L48.45,233l1.24-2a9.28,9.28,0,0,1-1-2.37l-2.34-.49-.07-3.95,2.32-.57Zm5.22,2.24A4.24,4.24,0,1,0,58,221.55,4.24,4.24,0,0,0,53.8,225.86Z",
    style: {
      fill: "#ebebeb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.34,159.92a22.21,22.21,0,0,1,2.17-5.49l-3-4.58,6.3-6.51,4.67,2.84a22.38,22.38,0,0,1,5.42-2.34l1.12-5.36,9.05-.15,1.3,5.32a22.37,22.37,0,0,1,5.49,2.17l4.58-3,6.5,6.29-2.84,4.68a22,22,0,0,1,2.35,5.41l5.36,1.13.14,9-5.31,1.29a22.06,22.06,0,0,1-2.17,5.49l3,4.58-6.3,6.51-4.67-2.84a22.4,22.4,0,0,1-5.42,2.35L435,192.12l-9,.15-1.3-5.32a22,22,0,0,1-5.49-2.17l-4.58,3-6.5-6.3,2.84-4.68a22,22,0,0,1-2.35-5.41l-5.35-1.12-.15-9.06,5.31-1.29Zm11.94,5.13a9.71,9.71,0,1,0,9.55-9.87A9.7,9.7,0,0,0,420.28,165.05Z",
    style: {
      fill: "#ebebeb",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.94,310.83a19.9,19.9,0,0,1,2-5l-2.71-4.15,5.7-5.89,4.23,2.58a19.83,19.83,0,0,1,4.9-2.13l1-4.85,8.19-.13,1.18,4.81a20.21,20.21,0,0,1,5,2l4.14-2.71,5.89,5.7-2.57,4.23a20.18,20.18,0,0,1,2.12,4.9l4.85,1,.14,8.19-4.82,1.18a20.19,20.19,0,0,1-2,5l2.71,4.14-5.7,5.89L93,333a20.26,20.26,0,0,1-4.9,2.13L87,340l-8.2.14-1.17-4.81a20.29,20.29,0,0,1-5-2l-4.15,2.71-5.89-5.7,2.58-4.24a19.51,19.51,0,0,1-2.13-4.9l-4.85-1-.13-8.2,4.81-1.17Zm10.8,4.64a8.8,8.8,0,1,0,8.65-8.93A8.79,8.79,0,0,0,73.74,315.47Z",
    style: {
      fill: "#f5f5f5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.89,141.28a9.07,9.07,0,0,1,.85-2.17l-1.18-1.8,2.49-2.57,1.84,1.12a8.8,8.8,0,0,1,2.13-.92l.45-2.11,3.56-.06.51,2.09a8.55,8.55,0,0,1,2.17.86l1.8-1.18,2.57,2.48L251,138.87a8.42,8.42,0,0,1,.92,2.13l2.11.44.06,3.57-2.09.51a8.7,8.7,0,0,1-.86,2.17l1.18,1.8-2.48,2.57L248,150.94a8.87,8.87,0,0,1-2.14.92l-.44,2.11-3.57.06-.51-2.09a8.48,8.48,0,0,1-2.16-.86l-1.81,1.18-2.56-2.48,1.12-1.85a8.82,8.82,0,0,1-.93-2.13l-2.11-.44-.06-3.57,2.1-.51Zm4.7,2a3.83,3.83,0,1,0,3.77-3.89A3.84,3.84,0,0,0,239.59,143.3Z",
    style: {
      fill: "#f5f5f5",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,390.92c4.5-2.32,9.79-2.62,14.78-1.8,2.69.45,5.48,1.25,7.31,3.26s2.17,5.56.07,7.29a6.91,6.91,0,0,1-4.6,1.17c-3.91,0-8.25-.73-11.37,1.62-1.78,1.34-3,3.57-5.1,4.23a5,5,0,0,1-5.54-2.46,8.6,8.6,0,0,1-.62-6.35A9.7,9.7,0,0,1,420,390.92Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.66,371c2.75,3.93,8.09,2.63,10.57.23s3.52-5.87,4.48-9.18c2.18-7.57,4.37-15.52,2.75-23.23a12.86,12.86,0,0,0-3-6.31,6.72,6.72,0,0,0-6.39-2.12c-2.69.71-4.37,3.35-5.58,5.86A55.35,55.35,0,0,0,407.06,360c0,3.83.44,7.84,2.6,11",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.11,376.67c3-3.55,3.55-8.72,2.22-13.16s-4.33-8.21-7.79-11.29a41.81,41.81,0,0,0-14-8.23,14.87,14.87,0,0,0-6.27-1.07,6.55,6.55,0,0,0-5.26,3.19c-1.47,2.8-.07,6.19,1.46,9A106.42,106.42,0,0,0,381.68,369c2.74,3.54,5.89,7,10.07,8.63s8.54,1.42,10.75-1.49",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.47,430.28a8.48,8.48,0,0,0,.25-1.79c.13-1.3.28-2.93.47-4.87a70.83,70.83,0,0,1,1.1-7.14,54.77,54.77,0,0,1,2.6-8.44,31.09,31.09,0,0,1,4.3-7.62,16,16,0,0,1,5.44-4.53,15.56,15.56,0,0,1,4.59-1.43,8.61,8.61,0,0,0,1.78-.25,7.68,7.68,0,0,0-1.81,0,14,14,0,0,0-4.78,1.24,16,16,0,0,0-5.74,4.57,30,30,0,0,0-4.47,7.78,52.18,52.18,0,0,0-2.58,8.57,62.27,62.27,0,0,0-.95,7.23c-.15,2.07-.21,3.75-.24,4.9A8.89,8.89,0,0,0,409.47,430.28Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.81,426.53a3.84,3.84,0,0,0,0-.83v-2.37c0-2.05,0-5,.1-8.7.19-7.34.82-15.25,2-26.39,1.16-10.48,2.71-22.68,4.35-30.61.35-1.8.7-3.42,1-4.84s.59-2.66.86-3.65.4-1.7.55-2.3a2.94,2.94,0,0,0,.14-.82,4,4,0,0,0-.28.78l-.69,2.27c-.31,1-.62,2.2-1,3.62s-.76,3-1.14,4.83a268.55,268.55,0,0,0-4.57,28.4c-1.23,11.17-1.78,21.34-1.83,28.7,0,3.68,0,6.66.13,8.72.06,1,.11,1.74.15,2.37A3.14,3.14,0,0,0,409.81,426.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.86,406.92a16.24,16.24,0,0,0,0-2.48c-.09-1.59-.31-3.88-.76-6.7A87.45,87.45,0,0,0,406.9,388a79.53,79.53,0,0,0-4.08-11.56,61.73,61.73,0,0,0-12-18.67,30.88,30.88,0,0,0-2.82-2.62c-.44-.37-.82-.73-1.21-1l-1.09-.76a15.66,15.66,0,0,0-2.09-1.33c-.11.16,2.95,2,6.83,6.09a64.87,64.87,0,0,1,11.69,18.6,91.53,91.53,0,0,1,4.11,11.45c1.07,3.59,1.78,6.89,2.32,9.67s.8,5.06,1,6.64A14.61,14.61,0,0,0,409.86,406.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390.9 441.51 392.87 468.43 427.45 468.43 429.42 441.51 390.9 441.51",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.56,
    y: 430.9,
    width: 45.98,
    height: 10.61,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.56 467.4 387.56 470.35 389.72 470.35 432.78 470.35 432.78 467.4 387.56 467.4",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.84 475.52 389.72 470.35 431.14 470.35 428.67 475.52 391.84 475.52",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.77,450.31s0,.09-.16.25l-.51.68-2,2.58-.09.12-.08-.12L421,447h.28l-4.87,6.9-.16.22-.17-.21L410.26,447h.34l-.32.4-5.17,6.48-.17.22-.16-.23L399.9,447l.29,0c-2.41,2.73-4.44,5.06-6,6.84l-.1.12-.09-.14-1.88-3.16-.48-.84a1.64,1.64,0,0,1-.15-.3,1.92,1.92,0,0,1,.21.27l.53.81,2,3.1H394c1.53-1.81,3.54-4.16,5.9-6.93l.15-.17.14.18,4.92,6.87h-.33l5.15-6.49.32-.4.16-.2.17.2,5.77,6.89H416l4.93-6.86.14-.2.14.2,4.85,6.92h-.18c.88-1.06,1.58-1.9,2.1-2.51l.56-.65Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.9,441.33c0,.12-8.67.22-19.36.22s-19.35-.1-19.35-.22,8.66-.21,19.35-.21S429.9,441.21,429.9,441.33Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.65,470.63c0,.12-9.42.22-21,.22s-21-.1-21-.22,9.42-.21,21-.21S431.65,470.52,431.65,470.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.42,169.17a10.87,10.87,0,0,1,1.79,0c.58,0,1.29,0,2.1.06s1.76.09,2.78.22a64.67,64.67,0,0,1,7.17,1.13A71.67,71.67,0,0,1,89.8,173a72,72,0,0,1,8.12,3.61,62.75,62.75,0,0,1,6.21,3.76c.87.56,1.6,1.14,2.27,1.62s1.21.93,1.65,1.31a12.38,12.38,0,0,1,1.34,1.19,10.53,10.53,0,0,1-1.47-1c-.46-.35-1-.77-1.7-1.23s-1.42-1-2.29-1.56c-1.71-1.13-3.83-2.37-6.23-3.63a76.93,76.93,0,0,0-8.08-3.55,77.6,77.6,0,0,0-8.46-2.5,72.05,72.05,0,0,0-7.11-1.24c-1-.15-1.94-.2-2.76-.29s-1.51-.12-2.09-.15A11.41,11.41,0,0,1,67.42,169.17Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.89,280.58a3.13,3.13,0,0,1,.54-.46l1.6-1.21c.69-.53,1.56-1.17,2.6-1.85s2.19-1.5,3.54-2.29,2.79-1.71,4.42-2.57,3.37-1.76,5.23-2.67a109,109,0,0,1,12.52-4.92,110.78,110.78,0,0,1,13.07-3.19c2-.32,4-.66,5.82-.83s3.53-.36,5.09-.45,3-.13,4.22-.16,2.31,0,3.18,0l2,.07a3.2,3.2,0,0,1,.7.06,3.45,3.45,0,0,1-.7,0l-2,0c-.87,0-1.94,0-3.18.08s-2.64.08-4.19.24-3.26.25-5.07.51-3.75.54-5.78.87a114.31,114.31,0,0,0-13,3.22A115.86,115.86,0,0,0,67,270c-1.85.9-3.62,1.73-5.22,2.62s-3.1,1.71-4.44,2.5-2.52,1.57-3.57,2.23-1.93,1.26-2.64,1.76l-1.66,1.14A4.71,4.71,0,0,1,48.89,280.58Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.76,334.33a2.15,2.15,0,0,1,.07-.54l.3-1.54c.13-.66.31-1.47.55-2.4s.48-2,.83-3.17c.65-2.34,1.54-5.08,2.67-8.09s2.53-6.24,4.18-9.56,3.44-6.36,5.15-9.08,3.4-5.06,4.89-7c.72-1,1.43-1.81,2-2.56s1.14-1.37,1.6-1.88l1-1.16c.25-.26.38-.39.4-.38a2.17,2.17,0,0,1-.32.45c-.25.33-.58.73-1,1.22s-.95,1.17-1.53,1.94-1.27,1.61-2,2.6c-1.44,1.93-3.06,4.31-4.77,7s-3.43,5.76-5.09,9.06-3,6.52-4.21,9.49-2.07,5.71-2.76,8c-.37,1.16-.64,2.22-.9,3.14s-.47,1.72-.63,2.38-.29,1.11-.4,1.51A2.61,2.61,0,0,1,120.76,334.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.62,59.85a4,4,0,0,1-.39.6L255,62.14c-.53.72-1.17,1.61-1.87,2.67s-1.55,2.24-2.39,3.6S249,71.24,248,72.87s-1.93,3.39-2.95,5.24c-2,3.75-4,8-5.83,12.47s-3.32,8.94-4.53,13c-.56,2-1.13,4-1.55,5.81s-.82,3.54-1.15,5.11-.57,3-.8,4.24-.4,2.34-.52,3.23-.24,1.52-.32,2a3.25,3.25,0,0,1-.15.7,3.9,3.9,0,0,1,0-.72c.06-.52.13-1.2.23-2s.22-2,.44-3.24.39-2.7.72-4.27.64-3.31,1.09-5.14,1-3.79,1.51-5.84c1.19-4.08,2.67-8.52,4.5-13.07s3.9-8.75,5.9-12.49c1-1.86,2-3.63,3-5.24s1.92-3.1,2.8-4.44,1.73-2.52,2.46-3.56,1.39-1.93,2-2.63.95-1.22,1.28-1.63A2.87,2.87,0,0,1,256.62,59.85Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.65,163.74a2.88,2.88,0,0,1-.6.11l-1.73.23-1.25.15c-.46.07-.95.18-1.47.27-1.06.22-2.27.39-3.57.77l-2,.53c-.72.19-1.44.46-2.19.7-1.53.46-3.09,1.14-4.74,1.81a57.83,57.83,0,0,0-18.89,13.27c-1.19,1.33-2.36,2.57-3.3,3.85-.48.63-1,1.21-1.41,1.81L304.26,189c-.8,1.09-1.37,2.18-1.93,3.09-.27.47-.54.89-.76,1.3l-.56,1.12-.8,1.55a2.44,2.44,0,0,1-.32.53,3.28,3.28,0,0,1,.22-.57c.19-.42.42-1,.72-1.6l.52-1.15c.21-.41.47-.84.73-1.32a36.3,36.3,0,0,1,1.87-3.16l1.18-1.78c.41-.62.91-1.21,1.39-1.85.94-1.3,2.1-2.56,3.29-3.91a56.24,56.24,0,0,1,19.05-13.38c1.67-.66,3.25-1.33,4.79-1.78.77-.23,1.5-.5,2.22-.68l2.07-.5a34.58,34.58,0,0,1,3.61-.69c.53-.09,1-.18,1.49-.23l1.26-.11,1.74-.13A2.18,2.18,0,0,1,346.65,163.74Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.18,223.25l-.26-.08-.75-.25-2.87-1-2.07-.76c-.76-.26-1.6-.51-2.5-.8-1.79-.56-3.81-1.27-6.11-1.85l-3.58-1c-1.25-.34-2.57-.6-3.92-.92-2.7-.67-5.64-1.16-8.71-1.72a150.92,150.92,0,0,0-40.57-1.24c-3.1.37-6.06.68-8.8,1.18-1.37.24-2.7.42-4,.68l-3.63.75c-2.33.44-4.39,1-6.22,1.48-.91.23-1.76.43-2.53.64l-2.12.63-2.92.86-.77.21a1,1,0,0,1-.27,0l.25-.1.75-.26,2.9-1,2.11-.67c.77-.23,1.62-.45,2.53-.7,1.82-.47,3.88-1.08,6.21-1.55l3.64-.79c1.26-.27,2.6-.46,4-.7,2.75-.53,5.71-.85,8.82-1.24a147.09,147.09,0,0,1,40.7,1.25c3.08.58,6,1.08,8.72,1.77,1.36.33,2.68.6,3.93,1l3.58,1c2.3.61,4.31,1.35,6.1,1.93.9.3,1.73.57,2.49.85l2.06.8,2.84,1.12.73.31C420.1,223.2,420.19,223.24,420.18,223.25Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Robot--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M175.84,45.12h1.32a13.95,13.95,0,0,1,13.95,13.95v3.77a13.95,13.95,0,0,1-13.95,13.95h-1.32a0,0,0,0,1,0,0V45.12A0,0,0,0,1,175.84,45.12Z",
    transform: "translate(10.33 146.97) rotate(-44.79)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.22,77.6h0l-22.33-22.5h0l.93-.93a13.9,13.9,0,0,1,9.85-4.06h.05a13.91,13.91,0,0,1,9.87,4.12l2.66,2.68a14,14,0,0,1-.07,19.77ZM166.94,55.09l22.28,22.44.92-.91a13.93,13.93,0,0,0,.07-19.69l-2.66-2.68a13.81,13.81,0,0,0-9.83-4.11h-.05a13.83,13.83,0,0,0-9.81,4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.86,121.34h1.32a13.95,13.95,0,0,1,13.95,13.95v3.77a14,14,0,0,1-14,14H97.86a0,0,0,0,1,0,0V121.34A0,0,0,0,1,97.86,121.34Z",
    transform: "translate(276.05 166.43) rotate(137.3)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.43,148.25h-.58a13.91,13.91,0,0,1-9.71-4.48L98.59,141a14,14,0,0,1,.79-19.75l1-.91,0,0,21.49,23.29,0,0-1,.9A13.86,13.86,0,0,1,111.43,148.25Zm-12-27A13.93,13.93,0,0,0,98.62,141l2.56,2.77a13.85,13.85,0,0,0,9.68,4.47h.57a13.83,13.83,0,0,0,9.43-3.69l1-.88-21.44-23.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.19,
    y: 89.53,
    width: 2.5,
    height: 20.69,
    transform: "translate(-42.59 110.68) rotate(-51.11)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.22,88.3a5.1,5.1,0,1,1-7.17.77A5.12,5.12,0,0,1,88.22,88.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.48,
    y: 70.93,
    width: 99.18,
    height: 74.84,
    rx: 16.5,
    transform: "translate(-32.18 138.62) rotate(-44.8)",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "150.5 57.18 148.29 48.75 142.54 49.7 140.88 43.61 142.76 43.18 144.07 47.61 149.81 46.83 152.21 55.48 150.5 57.18",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 101.79,
    y: 85.29,
    width: 85.13,
    height: 30.57,
    rx: 13.96,
    transform: "translate(-28.95 130.92) rotate(-44.8)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.66,95s.12-.16.37-.45a14.86,14.86,0,0,0,1.1-1.33,16.84,16.84,0,0,0,2.93-5.87,18.94,18.94,0,0,0,.67-4.7,18.57,18.57,0,0,0-.9-5.56,17.22,17.22,0,0,0-3.12-5.65l-1.18-1.3-1.28-1.28a26.54,26.54,0,0,0-2.76-2.52A17.67,17.67,0,0,0,166.27,63a17.88,17.88,0,0,0-8.56.5,17.5,17.5,0,0,0-4.12,1.92,21.42,21.42,0,0,0-3.62,3l-7.05,7-31.43,31.23a17.41,17.41,0,0,0-5,10.11,18.06,18.06,0,0,0,.18,5.59,17.88,17.88,0,0,0,3.44,7.41c.59.69,1.17,1.36,1.83,2a30.29,30.29,0,0,0,3.94,3.62,17.35,17.35,0,0,0,19,.87,18.61,18.61,0,0,0,2-1.33c.6-.51,1.19-1,1.74-1.57l3.29-3.25,12-11.85,17.37-17.13L176,96.55l1.24-1.2c.28-.26.44-.39.44-.39s-.13.15-.4.43l-1.21,1.24-4.67,4.7-17.26,17.25-11.93,11.9-3.27,3.26c-.56.55-1.17,1.08-1.77,1.6a19.85,19.85,0,0,1-2,1.38,17.84,17.84,0,0,1-19.52-.86,32.38,32.38,0,0,1-4-3.67c-.65-.63-1.26-1.34-1.87-2a20.56,20.56,0,0,1-1.56-2.33,17.65,17.65,0,0,1-2-5.3,18.52,18.52,0,0,1-.19-5.76,17.85,17.85,0,0,1,5.11-10.4l31.46-31.21,7.07-7a22,22,0,0,1,3.7-3.07,17.72,17.72,0,0,1,20.36.93,26.56,26.56,0,0,1,2.79,2.57l1.27,1.29L179,71.18A17.6,17.6,0,0,1,182.11,77a18.15,18.15,0,0,1,.86,5.65,19.29,19.29,0,0,1-.71,4.76,16.84,16.84,0,0,1-3,5.88,12.48,12.48,0,0,1-1.15,1.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.76,126.43a78.3,78.3,0,0,1-.39-9,75.7,75.7,0,0,1,.14-9,80.3,80.3,0,0,1,.38,9A79.51,79.51,0,0,1,125.76,126.43Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.47,116.72a74.85,74.85,0,0,1-9,.67,81.18,81.18,0,0,1-9,.15,75.16,75.16,0,0,1,9-.67A81,81,0,0,1,134.47,116.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.4,90.11a78.76,78.76,0,0,1-.39-9,75.37,75.37,0,0,1,.14-9,80.3,80.3,0,0,1,.38,9A79.51,79.51,0,0,1,161.4,90.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.11,80.4a80.16,80.16,0,0,1-9,.67,76.89,76.89,0,0,1-9,.14,79.21,79.21,0,0,1,9-.66A78.18,78.18,0,0,1,170.11,80.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 140.64,
    cy: 39.98,
    r: 5.1,
    transform: "translate(-0.6 2.18) rotate(-0.89)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.51,156.68a5.09,5.09,0,0,1-.88-.73c-.55-.49-1.32-1.22-2.27-2.12-1.89-1.8-4.49-4.33-7.32-7.14s-5.38-5.38-7.2-7.27a22.26,22.26,0,0,1-2.81-3.18,11.05,11.05,0,0,1,.84.77l2.23,2.15c2,1.91,4.5,4.41,7.3,7.16s5.39,5.38,7.22,7.25l2.15,2.24A4.71,4.71,0,0,1,156.51,156.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.82,113.05a4.79,4.79,0,0,1-.88-.73c-.54-.49-1.31-1.21-2.26-2.11-1.9-1.81-4.49-4.33-7.33-7.14s-5.38-5.39-7.19-7.28a22.6,22.6,0,0,1-2.81-3.17,7.79,7.79,0,0,1,.84.76l2.23,2.15,7.3,7.17c2.84,2.81,5.39,5.37,7.22,7.24l2.15,2.24A4.24,4.24,0,0,1,199.82,113.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.8,
    y: 116.58,
    width: 52.15,
    height: 5.72,
    transform: "translate(-36.5 151.76) rotate(-45.46)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.6,142.82a1.1,1.1,0,1,1-1-1.13A1.09,1.09,0,0,1,137.6,142.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.94,151.63a1.1,1.1,0,0,1-2.19-.09,1.1,1.1,0,0,1,2.19.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.62,92.91a1.1,1.1,0,0,1-1.14,1,1.1,1.1,0,1,1,.09-2.19A1.08,1.08,0,0,1,186.62,92.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,101.72a1.09,1.09,0,1,1-2.18-.09,1.09,1.09,0,1,1,2.18.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.45,144a27.16,27.16,0,0,0-2.31-2.05c-.75-.59-1.7-1.23-2.67-2.09a10.37,10.37,0,0,1-2.54-3.34,11.3,11.3,0,0,1-.79-7.48,8.89,8.89,0,0,1,.82-2.15c.28-.47.44-.72.47-.7a22.92,22.92,0,0,0-.93,2.93,11.54,11.54,0,0,0,.9,7.17c1.2,2.66,3.53,4.12,5,5.37A7,7,0,0,1,105.45,144Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.92,63.53c.1.1-10.41,10.48-23.47,23.17s-23.75,22.91-23.85,22.81S112,99,125.08,86.33,148.82,63.43,148.92,63.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.92,95.87c0,.06-.52,0-1.19-.45a4.1,4.1,0,0,1-1.2-5.6c.44-.69.88-.95.92-.9s-.28.41-.59,1.07a4.45,4.45,0,0,0-.36,2.76A4.4,4.4,0,0,0,83,95.13C83.51,95.61,84,95.79,83.92,95.87Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.46,43.69c0,.06-.57,0-1.28-.51a4.16,4.16,0,0,1-.78-6c.56-.67,1.08-.88,1.11-.83s-.37.38-.81,1a4.18,4.18,0,0,0,.71,5.55C139,43.42,139.49,43.61,139.46,43.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.32,51.71a22.58,22.58,0,0,0-4.11.94,23.1,23.1,0,0,0-3.63,2.13A6.58,6.58,0,0,1,173,52.16,6.69,6.69,0,0,1,177.32,51.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.81,158.46a103.24,103.24,0,0,1-7.47-7.35c-4-4.16-7.19-7.61-7.08-7.71s3.44,3.19,7.46,7.35S135.91,158.36,135.81,158.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.44,
    y: 398.62,
    width: 42.79,
    height: 60.65,
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.77,458.23h42.14a5.7,5.7,0,0,1,5.7,5.7v.54a0,0,0,0,1,0,0H203.06a0,0,0,0,1,0,0v-.54A5.7,5.7,0,0,1,208.77,458.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.18,
    y: 464.47,
    width: 64.99,
    height: 9.88,
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,452.61c0,.14-9.48.26-21.18.26s-21.19-.12-21.19-.26,9.48-.26,21.19-.26S251,452.46,251,452.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,445.39c0,.15-9.48.26-21.18.26s-21.19-.11-21.19-.26,9.48-.26,21.19-.26S251,445.25,251,445.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,438.31c0,.14-9.48.26-21.18.26s-21.19-.12-21.19-.26,9.48-.26,21.19-.26S251,438.17,251,438.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,431.1c0,.14-9.48.26-21.18.26s-21.19-.12-21.19-.26,9.48-.26,21.19-.26S251,431,251,431.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,424c0,.15-9.48.26-21.18.26s-21.19-.11-21.19-.26,9.48-.26,21.19-.26S251,423.87,251,424Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,416.8c0,.15-9.48.26-21.18.26s-21.19-.11-21.19-.26,9.48-.26,21.19-.26S251,416.66,251,416.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,409.72c0,.14-9.48.26-21.18.26s-21.19-.12-21.19-.26,9.48-.26,21.19-.26S251,409.57,251,409.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251,402.51c0,.14-9.48.26-21.18.26s-21.19-.12-21.19-.26,9.48-.26,21.19-.26S251,402.36,251,402.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "208.44 407.07 251.02 405.89 251.02 399.71 208.06 399.71 208.44 407.07"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 275.46,
    y: 398.62,
    width: 42.79,
    height: 60.65,
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.79,458.23h42.14a5.7,5.7,0,0,1,5.7,5.7v.54a0,0,0,0,1,0,0H270.08a0,0,0,0,1,0,0v-.54A5.7,5.7,0,0,1,275.79,458.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.2,
    y: 464.47,
    width: 64.99,
    height: 9.88,
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,452.61c0,.14-9.48.26-21.18.26s-21.19-.12-21.19-.26,9.48-.26,21.19-.26S318,452.46,318,452.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,445.39c0,.15-9.48.26-21.18.26s-21.19-.11-21.19-.26,9.48-.26,21.19-.26S318,445.25,318,445.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,438.31c0,.14-9.48.26-21.18.26s-21.19-.12-21.19-.26,9.48-.26,21.19-.26S318,438.17,318,438.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,431.1c0,.14-9.48.26-21.18.26s-21.19-.12-21.19-.26,9.48-.26,21.19-.26S318,431,318,431.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,424c0,.15-9.48.26-21.18.26s-21.19-.11-21.19-.26,9.48-.26,21.19-.26S318,423.87,318,424Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,416.8c0,.15-9.48.26-21.18.26s-21.19-.11-21.19-.26,9.48-.26,21.19-.26S318,416.66,318,416.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,409.72c0,.14-9.48.26-21.18.26s-21.19-.12-21.19-.26,9.48-.26,21.19-.26S318,409.57,318,409.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318,402.51c0,.14-9.48.26-21.18.26s-21.19-.12-21.19-.26,9.48-.26,21.19-.26S318,402.36,318,402.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "275.46 407.07 318.04 405.89 318.04 399.71 275.08 399.71 275.46 407.07"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M328.17,223.65h4.32a1.83,1.83,0,0,1,1.83,1.83v17.68a0,0,0,0,1,0,0h-8a0,0,0,0,1,0,0V225.49a1.83,1.83,0,0,1,1.83-1.83Z",
    transform: "translate(23.16 496.55) rotate(-75.83)",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M328.17,223.65h4.32a1.83,1.83,0,0,1,1.83,1.83v17.68a0,0,0,0,1,0,0h-8a0,0,0,0,1,0,0V225.49a1.83,1.83,0,0,1,1.83-1.83Z",
    transform: "translate(23.16 496.55) rotate(-75.83)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M323.82,237.7h5.94a3,3,0,0,1,3,3v16.47a0,0,0,0,1,0,0h-12a0,0,0,0,1,0,0V240.74A3,3,0,0,1,323.82,237.7Z",
    transform: "translate(6.87 503.72) rotate(-75.83)",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.34,
    y: 237.02,
    width: 20.39,
    height: 7.7,
    transform: "translate(19.11 506.26) rotate(-75.83)",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.68,310.42s31.95-1.3,29.31-31.92c-2-23.45-36.91-23.66-36.91-23.66L347,235.35s40.76,3.55,48.81,33.23c9.09,33.54-11.93,60.89-50.13,60.25Z",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.32,
    y: 230.94,
    width: 12.44,
    height: 27.68,
    transform: "translate(60.85 -67.72) rotate(12.46)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.16,256.78c0,.23-2.76-.24-6.05-1a35.59,35.59,0,0,1-5.91-1.64,37.84,37.84,0,0,1,6,1.13c1.65.38,3.14.74,4.21,1l1.27.34A2.12,2.12,0,0,1,344.16,256.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.23,251.91c0,.23-2.75-.24-6.05-1a34.18,34.18,0,0,1-5.9-1.64,38.26,38.26,0,0,1,6,1.13c1.65.38,3.13.74,4.21,1l1.26.34A1.7,1.7,0,0,1,345.23,251.91Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.52,247c0,.24-2.76-.23-6-1a35.59,35.59,0,0,1-5.91-1.64,38.05,38.05,0,0,1,6,1.13c1.64.37,3.13.73,4.2,1l1.27.33Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.38,242.18c0,.23-2.75-.24-6-1a34.47,34.47,0,0,1-5.91-1.64,38,38,0,0,1,6,1.13c1.65.38,3.13.74,4.21,1l1.26.34A1.7,1.7,0,0,1,347.38,242.18Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.63,237.62c0,.24-2.75-.23-6-1a35.59,35.59,0,0,1-5.91-1.64,38,38,0,0,1,6,1.13c1.65.37,3.14.73,4.21,1l1.27.33A3.68,3.68,0,0,1,348.63,237.62Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.66,328.63a14.23,14.23,0,0,1-.65-2.7c-.32-1.68-.7-4-1-6.61s-.45-5-.51-6.67a13.76,13.76,0,0,1,0-2.78,14.56,14.56,0,0,1,.34,2.75c.15,1.7.36,4.05.66,6.64s.61,4.92.84,6.61A15.65,15.65,0,0,1,352.66,328.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.59,327.08a93.17,93.17,0,0,1-2.91-9.54,95,95,0,0,1-2.41-9.69,96,96,0,0,1,2.91,9.55A97.71,97.71,0,0,1,362.59,327.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.94,322.3a18.68,18.68,0,0,1-1.71-2.65c-1.08-1.8-2.41-4-3.89-6.52l-3.92-6.5a20.32,20.32,0,0,1-1.54-2.75,17.48,17.48,0,0,1,1.85,2.55c1.08,1.62,2.53,3.89,4,6.43s2.85,4.89,3.77,6.61A18.81,18.81,0,0,1,375.94,322.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.17,313.3c-.1.11-4.07-3-8.88-7s-8.64-7.32-8.55-7.43,4.07,3,8.88,7S387.26,313.18,387.17,313.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.4,301c-.06.14-4.76-1.7-10.51-4.09s-10.36-4.44-10.3-4.57,4.76,1.7,10.5,4.09S394.45,300.82,394.4,301Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.94,287.63a24.32,24.32,0,0,1-3.37-.32l-8.08-1-8.09-1a20.82,20.82,0,0,1-3.34-.51,20.89,20.89,0,0,1,3.38.14c2.08.16,4.95.44,8.11.83s6,.8,8.08,1.15A20,20,0,0,1,397.94,287.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.29,273.81a17.51,17.51,0,0,1-3,1c-1.89.55-4.53,1.23-7.47,1.85s-5.63,1.06-7.58,1.32a17.3,17.3,0,0,1-3.17.27,22.63,22.63,0,0,1,3.12-.64c1.93-.35,4.59-.84,7.52-1.46s5.57-1.24,7.48-1.7A22.07,22.07,0,0,1,396.29,273.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.27,260.55c.06.13-4.22,2.42-9.57,5.12s-9.74,4.78-9.81,4.65,4.22-2.42,9.57-5.12S392.2,260.43,392.27,260.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384,249.8c.09.11-3.47,3.33-8,7.2s-8.2,6.91-8.29,6.8,3.46-3.33,8-7.2S383.94,249.69,384,249.8Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.13,241.82c.12.07-2.13,4-5,8.83a97,97,0,0,1-5.48,8.57c-.12-.07,2.13-4,5-8.84A100,100,0,0,1,370.13,241.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.68,236.82a102.11,102.11,0,0,1-3,9.86c-1.78,5.4-3.34,9.74-3.47,9.7a98.49,98.49,0,0,1,3-9.87A99.79,99.79,0,0,1,357.68,236.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M372.68,294.18a24.63,24.63,0,0,1-11.58,11.88,36.5,36.5,0,0,1-7.84,3.06c6.11,3.26,14.09,1.31,19.43-3.1s8.16-11.41,8.35-18.34a21.73,21.73,0,0,0-1.73-9.6c-1.36-3-3.61-6.12-6.58-7.5a18.45,18.45,0,0,1,1.86,5.25A30.68,30.68,0,0,1,372.68,294.18Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M137.83,348.12a8.6,8.6,0,0,1,1,1.11c.62.73,1.46,1.82,2.46,3.21A70.45,70.45,0,0,1,147.9,364a68.72,68.72,0,0,1,4.29,12.63c.39,1.66.65,3,.79,4a9.26,9.26,0,0,1,.17,1.48,7.49,7.49,0,0,1-.37-1.44c-.2-.93-.52-2.27-.94-3.91a82,82,0,0,0-4.41-12.51A81.16,81.16,0,0,0,141,352.65c-.95-1.41-1.74-2.53-2.31-3.3A7.57,7.57,0,0,1,137.83,348.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.58,344.58c.1-.11.57.15,1.06.59s.8.87.71,1-.57-.15-1.06-.59S133.49,344.68,133.58,344.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.56,341.64c.12-.07.61.52,1.1,1.34s.78,1.53.66,1.6-.62-.52-1.11-1.34S134.43,341.71,134.56,341.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.06,382.72a5.24,5.24,0,0,1,.15-.8q.21-.85.54-2.28c.47-2,1.14-4.84,1.91-8.39,1.54-7.1,3.41-17,4.78-28,.74-5.48,1-10.8,2.28-15.49a23.67,23.67,0,0,1,2.68-6.31,18.86,18.86,0,0,1,11.72-8.23,15,15,0,0,1,2.32-.35,4.61,4.61,0,0,1,.82,0,6.05,6.05,0,0,1-.81.12,21.6,21.6,0,0,0-2.29.44,19.47,19.47,0,0,0-7.54,3.86,18.55,18.55,0,0,0-3.85,4.4,23.25,23.25,0,0,0-2.59,6.22c-1.24,4.62-1.49,9.93-2.22,15.43-1.38,11-3.31,20.89-4.94,28-.82,3.55-1.55,6.4-2.07,8.36q-.4,1.41-.63,2.25A4.88,4.88,0,0,1,153.06,382.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.25,303.42a16,16,0,0,0,2.55,3.72,16.81,16.81,0,0,0,9.61,4.68,36.36,36.36,0,0,0,10.92-.46l3.29-.58a6.67,6.67,0,0,1,1.22-.16,5.25,5.25,0,0,1-1.18.36c-.77.19-1.88.46-3.27.74a32.92,32.92,0,0,1-11,.61,16.48,16.48,0,0,1-9.81-4.94,10.79,10.79,0,0,1-1.88-2.81A4,4,0,0,1,154.25,303.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.45,300.26c.1-.1.58.21,1.06.7s.8,1,.7,1.06-.58-.21-1.06-.69S150.35,300.36,150.45,300.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.58,298.52c.13-.08.58.43,1,1.13s.69,1.34.56,1.41-.57-.43-1-1.13S151.46,298.59,151.58,298.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.71,298.29c.15,0,.17.61.06,1.32s-.32,1.25-.46,1.23-.17-.61-.06-1.32S154.57,298.27,154.71,298.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.13,337.34a10.35,10.35,0,0,1-.08,1.78c-.09,1.15-.26,2.8-.5,4.83-.47,4.08-1.3,9.68-2.55,15.81s-2.69,11.62-3.84,15.56c-.58,2-1.08,3.55-1.44,4.63a12.65,12.65,0,0,1-.62,1.67,13.26,13.26,0,0,1,.42-1.73c.33-1.18.76-2.76,1.28-4.67,1.06-4,2.44-9.44,3.69-15.56s2.13-11.7,2.7-15.75c.27-2,.49-3.59.65-4.81A14.78,14.78,0,0,1,164.13,337.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.86,314.19c0,.1-1.43.11-3.64.69a18.05,18.05,0,0,0-12.54,11.58c-.76,2.15-.88,3.59-1,3.57a2.79,2.79,0,0,1,0-1,15,15,0,0,1,.58-2.68,17.37,17.37,0,0,1,12.8-11.82,15.36,15.36,0,0,1,2.72-.37A3.48,3.48,0,0,1,181.86,314.19Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.8,382.51a5.24,5.24,0,0,1,0-.75c0-.49.12-1.22.25-2.15a20,20,0,0,1,2.37-7.57c.84-1.47,2-2.91,2.94-4.61a9.67,9.67,0,0,0,1-2.78,11.45,11.45,0,0,0,.08-3.16c-.16-2.17-.79-4.51-.3-7a8.54,8.54,0,0,1,1.6-3.39c.73-1,1.58-2,2.25-3a6.36,6.36,0,0,0,1.12-3.41,14.83,14.83,0,0,0-.48-3.57,21.11,21.11,0,0,1-.58-7,19.9,19.9,0,0,1,10.54-15.89,17.52,17.52,0,0,1,2-.88,4.26,4.26,0,0,1,.72-.23,3.85,3.85,0,0,1-.68.32c-.45.21-1.11.51-1.92,1a20.47,20.47,0,0,0-5.95,5.08,19.71,19.71,0,0,0-4.21,10.67,20.85,20.85,0,0,0,.6,6.82,15.28,15.28,0,0,1,.5,3.69,6.87,6.87,0,0,1-1.21,3.68c-.7,1.11-1.55,2.05-2.26,3.05a7.83,7.83,0,0,0-1.52,3.19c-.47,2.31.12,4.62.28,6.84a12,12,0,0,1-.11,3.29,10.21,10.21,0,0,1-1.11,2.9c-1,1.74-2.16,3.16-3,4.59a20.78,20.78,0,0,0-2.48,7.42c-.15.88-.26,1.59-.35,2.12A3.76,3.76,0,0,1,157.8,382.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183,324.55a9.45,9.45,0,0,0-2.46.35,9.77,9.77,0,0,0-5.17,4.13c-1.6,2.39-2.31,5.82-2.69,9.6A121.14,121.14,0,0,1,170.89,351a200.58,200.58,0,0,1-6,21.82c-.9,2.75-1.65,5-2.19,6.49-.25.72-.46,1.3-.62,1.75a2.49,2.49,0,0,1-.26.6A4.25,4.25,0,0,1,162,381c.13-.46.31-1.05.53-1.78l2-6.54c1.69-5.53,4-13.18,5.8-21.82.88-4.31,1.46-8.46,1.86-12.27s1.17-7.3,2.87-9.74a9.74,9.74,0,0,1,5.42-4.12,6.25,6.25,0,0,1,1.86-.23A4.13,4.13,0,0,1,183,324.55Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.29,378.93h19.37s-11.75,93.29-76.61,93l.83-18.19S134,451,146.29,378.93Z",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7,442.54H75a1.83,1.83,0,0,1,1.83,1.83V462a0,0,0,0,1,0,0h-8a0,0,0,0,1,0,0V444.37A1.83,1.83,0,0,1,70.7,442.54Z",
    transform: "translate(-380.65 517.19) rotate(-88.99)",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7,442.54H75a1.83,1.83,0,0,1,1.83,1.83V462a0,0,0,0,1,0,0h-8a0,0,0,0,1,0,0V444.37A1.83,1.83,0,0,1,70.7,442.54Z",
    transform: "translate(-380.65 517.19) rotate(-88.99)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M69.64,457h5.94a3,3,0,0,1,3,3v16.47a0,0,0,0,1,0,0h-12a0,0,0,0,1,0,0V460.06A3,3,0,0,1,69.64,457Z",
    transform: "matrix(0.02, -1, 1, 0.02, -395.38, 531.17)",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 68.46,
    y: 454.75,
    width: 20.39,
    height: 7.7,
    transform: "translate(-381.26 529.18) rotate(-88.99)",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.17,
    y: 447.2,
    width: 12.44,
    height: 27.68,
    transform: "translate(-5.62 1.08) rotate(-0.7)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.64,471.9c0,.23-2.74.4-6.11.42a34.37,34.37,0,0,1-6.13-.26,38.67,38.67,0,0,1,6.12-.27c1.69,0,3.22,0,4.33,0l1.31,0A2.44,2.44,0,0,1,91.64,471.9Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.58,466.92c0,.23-2.74.39-6.11.41a35,35,0,0,1-6.13-.25,38.67,38.67,0,0,1,6.12-.27c1.69,0,3.22,0,4.33,0l1.31,0A1.75,1.75,0,0,1,91.58,466.92Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.72,461.89c0,.23-2.73.39-6.11.41a34.92,34.92,0,0,1-6.12-.25,38.67,38.67,0,0,1,6.12-.27c1.69,0,3.22,0,4.32,0l1.31,0A2,2,0,0,1,91.72,461.89Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.46,457c0,.23-2.74.4-6.12.42a34.29,34.29,0,0,1-6.12-.26,38.67,38.67,0,0,1,6.12-.27c1.69,0,3.22,0,4.33,0l1.31,0A2.57,2.57,0,0,1,91.46,457Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.64,452.23c0,.23-2.74.4-6.11.42a36.2,36.2,0,0,1-6.13-.25,36,36,0,0,1,6.12-.27c1.69,0,3.22,0,4.33,0l1.31,0A2.44,2.44,0,0,1,91.64,452.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.44,471s0,.16.06.5l0,.58-.17-.56a83.2,83.2,0,0,1-1.91-9.16c-.43-2.69-.72-5.13-.89-6.91a14.66,14.66,0,0,1-.13-2.89,18.89,18.89,0,0,1,.5,2.85c.25,1.76.6,4.19,1,6.87.69,4.34,1.4,8,1.55,9.2l-.16,0C98.38,471.14,98.41,471,98.44,471Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.64,469.21a92.86,92.86,0,0,1-3.22-9.42,92.86,92.86,0,0,1-2.73-9.57,92.86,92.86,0,0,1,3.22,9.42A92.86,92.86,0,0,1,107.64,469.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.51,464.62a98.81,98.81,0,0,1-4.78-9.06c-2.5-5.08-4.43-9.24-4.3-9.3a99.8,99.8,0,0,1,4.77,9.07C116.71,460.4,118.63,464.56,118.51,464.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.14,457.42a91.87,91.87,0,0,1-6.18-7.91,98.59,98.59,0,0,1-5.77-8.23,96.34,96.34,0,0,1,6.19,7.92C125.67,453.66,128.25,457.34,128.14,457.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.55,449.44a93.69,93.69,0,0,1-7.2-6.85,96.19,96.19,0,0,1-6.82-7.22,94.54,94.54,0,0,1,7.19,6.85A97.73,97.73,0,0,1,136.55,449.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.48,439.86a14.64,14.64,0,0,1-2.51-1.34l-5.92-3.46-5.91-3.45a15.52,15.52,0,0,1-2.41-1.53,15.05,15.05,0,0,1,2.58,1.21c1.56.81,3.69,2,6,3.32s4.37,2.64,5.84,3.6A15.72,15.72,0,0,1,143.48,439.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.17,430.16a13.82,13.82,0,0,1-2.43-1.09c-1.47-.72-3.51-1.71-5.77-2.76s-4.34-1.95-5.84-2.61a15.48,15.48,0,0,1-2.41-1.14,11.93,11.93,0,0,1,2.54.8c1.54.57,3.65,1.43,5.93,2.48s4.29,2.1,5.72,2.9A13.26,13.26,0,0,1,148.17,430.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.77,420.78a13.93,13.93,0,0,1-2.77-.46c-1.7-.37-4-.94-6.57-1.68s-4.82-1.51-6.45-2.11a14.17,14.17,0,0,1-2.59-1.09,16.24,16.24,0,0,1,2.71.74c1.65.51,3.94,1.22,6.47,2s4.84,1.36,6.51,1.82A16.1,16.1,0,0,1,153.77,420.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.76,411.32a84.29,84.29,0,0,1-9.25-.92,84.45,84.45,0,0,1-9.18-1.43,84.06,84.06,0,0,1,9.25.92A79,79,0,0,1,156.76,411.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.94,402.07a12.64,12.64,0,0,1-2.69-.08c-1.66-.12-3.95-.32-6.47-.57s-4.81-.51-6.45-.73a13.79,13.79,0,0,1-2.66-.45,14.26,14.26,0,0,1,2.7.09c1.66.12,3.94.32,6.46.57s4.8.51,6.45.72A14.83,14.83,0,0,1,159.94,402.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.39,393.11a92.12,92.12,0,0,1-9.64.56,86.39,86.39,0,0,1-9.65,0,92.12,92.12,0,0,1,9.64-.56A89.44,89.44,0,0,1,162.39,393.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.4,385.79a13.17,13.17,0,0,1-2.64.41c-1.64.17-3.91.31-6.42.32s-4.79-.11-6.43-.26a12.81,12.81,0,0,1-2.64-.38,15,15,0,0,1,2.66,0c1.64.06,3.9.13,6.4.11s4.77-.1,6.4-.17A15,15,0,0,1,163.4,385.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.13,381.7a.72.72,0,0,1,0,.25v.74c0,.65,0,1.61-.07,2.84a74,74,0,0,1-1.23,10.39,78.32,78.32,0,0,1-4.35,14.89,77.44,77.44,0,0,1-22,30.58,78.86,78.86,0,0,1-12.76,8.83,73.1,73.1,0,0,1-9.47,4.45c-1.14.46-2.06.74-2.67,1l-.7.23a.8.8,0,0,1-.25.06.7.7,0,0,1,.23-.11l.68-.28c.6-.25,1.51-.56,2.64-1a82.14,82.14,0,0,0,9.36-4.58,79.89,79.89,0,0,0,39-54,81.57,81.57,0,0,0,1.39-10.33c.11-1.22.11-2.18.16-2.83,0-.3,0-.54,0-.74A.87.87,0,0,1,147.13,381.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.92,273s-10.72-14.51-35.53-12.36c0,0,25.25-19.4,10.39-39.33,0,0,31.89,9.42,32.25-30.44,0,0,5.8,37,35.88,26.46,0,0,2.14,29.36,22.95,23.93C292.79,251.16,283,259.89,285,272.55",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.92,273s-10.72-14.51-35.53-12.36c0,0,25.25-19.4,10.39-39.33,0,0,31.89,9.42,32.25-30.44,0,0,5.8,37,35.88,26.46,0,0,2.14,29.36,22.95,23.93C292.79,251.16,283,259.89,285,272.55",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M236.92,273s-.25-16.92-20.18-15.19c0,0,18.53-10.69,6.6-26.7,0,0,25.62,7.57,25.91-24.45,0,0,4.65,29.69,28.82,21.25,0,0-2.89,21.54,13.84,17.17-8.09,8-11.37,17-9.77,27.2",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.92,273s-.25-16.92-20.18-15.19c0,0,18.53-10.69,6.6-26.7,0,0,25.62,7.57,25.91-24.45,0,0,4.65,29.69,28.82,21.25,0,0-2.89,21.54,13.84,17.17-8.09,8-11.37,17-9.77,27.2",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M269.65,160.76a5.13,5.13,0,0,1-.24.63l-.79,1.76c-.35.76-.77,1.69-1.22,2.8s-1,2.33-1.51,3.74-1.13,2.93-1.68,4.6-1.12,3.46-1.7,5.35c-1.09,3.8-2.13,8-2.95,12.52s-1.3,8.82-1.6,12.76c-.12,2-.25,3.85-.27,5.61s-.05,3.4,0,4.89.08,2.85.12,4,.1,2.21.17,3,.09,1.43.12,1.92a3,3,0,0,1,0,.68,5.34,5.34,0,0,1-.11-.67q-.07-.74-.21-1.92c-.1-.83-.2-1.85-.26-3s-.18-2.55-.19-4-.08-3.14,0-4.91.12-3.65.22-5.63a113.18,113.18,0,0,1,4.57-25.39c.59-1.89,1.14-3.7,1.75-5.35s1.18-3.2,1.74-4.59,1.12-2.64,1.6-3.73.92-2,1.3-2.77l.87-1.72A3,3,0,0,1,269.65,160.76Z",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.07,153.89a33,33,0,0,0-6-4.49,33.26,33.26,0,0,0-7.06-2.52,6.79,6.79,0,0,1,2.23.22,18.55,18.55,0,0,1,5.08,1.84,18.9,18.9,0,0,1,4.34,3.21A6.55,6.55,0,0,1,198.07,153.89Z",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.75,197.42a2.34,2.34,0,0,1,.42.4l1.11,1.19c1,1,2.31,2.59,3.91,4.56s3.43,4.37,5.36,7.11,3.92,5.86,5.86,9.2,3.62,6.64,5.06,9.67,2.6,5.82,3.5,8.19,1.59,4.31,2,5.66q.28.94.48,1.56a2.26,2.26,0,0,1,.13.56,2.26,2.26,0,0,1-.23-.53l-.58-1.52c-.47-1.33-1.2-3.25-2.15-5.59s-2.16-5.1-3.59-8.12-3.15-6.27-5.08-9.62-3.92-6.42-5.8-9.18-3.69-5.18-5.26-7.16-2.85-3.58-3.77-4.66l-1-1.25A2.44,2.44,0,0,1,205.75,197.42Z",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.51,202.53a1.72,1.72,0,0,1-.21.46l-.67,1.25c-.31.54-.67,1.2-1.06,2s-.87,1.66-1.32,2.67c-1,2-2,4.42-3,7.16a78.08,78.08,0,0,0-4.16,18.47c-.27,2.9-.39,5.53-.38,7.74,0,1.1,0,2.1.05,3s.06,1.63.1,2.25.05,1,.07,1.42a1.37,1.37,0,0,1,0,.5,2.25,2.25,0,0,1-.09-.49c-.05-.38-.1-.85-.17-1.42s-.15-1.37-.19-2.25-.13-1.88-.13-3a71,71,0,0,1,.28-7.79,72.75,72.75,0,0,1,4.18-18.58,70.42,70.42,0,0,1,3.09-7.16c.47-1,1-1.87,1.4-2.65s.8-1.43,1.13-2,.56-.88.76-1.21A2,2,0,0,1,274.51,202.53Z",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.15,206.41c.05.06-.83.71-2.16,1.87a36.84,36.84,0,0,0-8.52,10.7,26.43,26.43,0,0,1-1.35,2.53,11.4,11.4,0,0,1,1-2.7,30.94,30.94,0,0,1,3.68-5.9,30.11,30.11,0,0,1,4.93-4.91A11.07,11.07,0,0,1,294.15,206.41Z",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.65,231.91a11.93,11.93,0,0,1,2.44,1.53,34.6,34.6,0,0,1,5.16,4.68,33.84,33.84,0,0,1,4.12,5.61,11.66,11.66,0,0,1,1.27,2.59,27.69,27.69,0,0,1-1.58-2.4,45,45,0,0,0-4.2-5.46,45.57,45.57,0,0,0-5-4.73A22.61,22.61,0,0,1,210.65,231.91Z",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.58,222.61c-.08.14-2.12-1-4.88-1.7s-5.09-.71-5.09-.87a14.5,14.5,0,0,1,10,2.57Z",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,191.31a6.85,6.85,0,0,1,.66-1.66l-.91-1.38,1.9-2,1.41.85a7.26,7.26,0,0,1,1.64-.71l.34-1.61,2.73-.05.39,1.61a7,7,0,0,1,1.66.65l1.38-.9,2,1.9-.86,1.41a6.31,6.31,0,0,1,.71,1.64l1.62.33,0,2.74-1.6.39a6.78,6.78,0,0,1-.66,1.65l.91,1.39-1.9,2L195,198.7a6.25,6.25,0,0,1-1.63.71L193,201l-2.73,0-.39-1.6a6.85,6.85,0,0,1-1.66-.66l-1.38.9-2-1.9.86-1.41a6.25,6.25,0,0,1-.71-1.63l-1.62-.34,0-2.73,1.6-.39Zm3.6,1.55a2.93,2.93,0,1,0,2.88-3A2.93,2.93,0,0,0,188.61,192.86Z",
    style: {
      fill: "#769A93",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.57,265.2a5.17,5.17,0,0,1,.48-1.22l-.67-1,1.41-1.45,1,.63a5.13,5.13,0,0,1,1.2-.52l.25-1.19,2,0,.29,1.19a4.77,4.77,0,0,1,1.22.48l1-.67,1.45,1.41-.63,1a5,5,0,0,1,.52,1.2l1.19.25,0,2-1.19.29a5.17,5.17,0,0,1-.48,1.22l.66,1-1.4,1.45-1-.63a5,5,0,0,1-1.21.52l-.24,1.19-2,0-.29-1.18a5.17,5.17,0,0,1-1.22-.48l-1,.66L299.5,270l.63-1a5,5,0,0,1-.52-1.21l-1.19-.25,0-2,1.19-.29Zm2.66,1.14a2.16,2.16,0,1,0,4.32-.07,2.16,2.16,0,1,0-4.32.07Z",
    style: {
      fill: "#455a64",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.18,
    y: 182.1,
    width: 10.43,
    height: 4.72,
    transform: "translate(-7.11 357.67) rotate(-64.59)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,188.16a10.74,10.74,0,0,1,1.23.49c.76.32,1.83.78,3.11,1.36l-.25.09c1.12-2.45,2.67-5.79,4.41-9.45-.11-.31.15.43.12.35h-.06l-.07,0-.14-.06-.28-.14-.56-.26-1.08-.52-2.06-1,.33-.11c-1.29,2.68-2.45,5-3.28,6.64-.4.76-.73,1.41-1,1.95a4.56,4.56,0,0,1-.41.72,3.13,3.13,0,0,1,.26-.68c.23-.54.52-1.19.85-1.95.75-1.69,1.83-4.1,3.14-6.89l.11-.23.22.11,2.07,1,1.09.51.55.26.28.14.14.06.07,0h.07c0-.08.23.66.12.35-1.74,3.66-3.34,7-4.54,9.39l-.08.17-.17-.09c-1.34-.66-2.41-1.21-3.12-1.59A7.68,7.68,0,0,1,275,188.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.35,175.75a4.34,4.34,0,0,0-5.79,2.06l7.86,3.74A4.35,4.35,0,0,0,283.35,175.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.35,175.75a1.2,1.2,0,0,1,.49.18,4.22,4.22,0,0,1,1.12.9,4.28,4.28,0,0,1,1,2,4.45,4.45,0,0,1-.32,2.83l-.09.22-.23-.1-3.93-1.85L277.45,178l-.22-.1.11-.22a4.54,4.54,0,0,1,2-2,4.4,4.4,0,0,1,2.17-.48,3.86,3.86,0,0,1,1.4.3c.31.14.46.24.44.26a8.45,8.45,0,0,0-1.84-.27,4.22,4.22,0,0,0-2,.55,4.16,4.16,0,0,0-1.76,1.89l-.11-.32,3.94,1.85,3.92,1.88-.32.12a4.19,4.19,0,0,0,.36-2.56,4.35,4.35,0,0,0-.83-1.88A8,8,0,0,0,283.35,175.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.45,178.24a2.74,2.74,0,0,0-.86-2.8",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.59,175.44c.07-.13.8.27,1.08,1.2s-.09,1.66-.22,1.6,0-.71-.27-1.45S282.5,175.56,282.59,175.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.65,180.07a9,9,0,0,1,2.28.94,9.17,9.17,0,0,1,2.23,1.09,4.68,4.68,0,0,1-2.44-.62C279.44,180.91,278.57,180.18,278.65,180.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.12,181.17a9.71,9.71,0,0,1,2.29,1,9.17,9.17,0,0,1,2.22,1.08,4.52,4.52,0,0,1-2.44-.61C278.92,182,278,181.29,278.12,181.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.6,182.28a9,9,0,0,1,2.28.94,9.41,9.41,0,0,1,2.23,1.09,4.72,4.72,0,0,1-2.44-.61C278.39,183.12,277.52,182.39,277.6,182.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.07,183.38a9.71,9.71,0,0,1,2.29,1,9.17,9.17,0,0,1,2.22,1.08,4.52,4.52,0,0,1-2.44-.61C277.87,184.23,277,183.5,277.07,183.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.54,184.49a9.26,9.26,0,0,1,2.29.94,9.87,9.87,0,0,1,2.23,1.09,7.15,7.15,0,0,1-4.52-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276,185.6a9,9,0,0,1,2.29.94,9.21,9.21,0,0,1,2.22,1.09,7.23,7.23,0,0,1-4.51-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.49,186.7a9.54,9.54,0,0,1,2.29,1,9.17,9.17,0,0,1,2.22,1.08,4.48,4.48,0,0,1-2.43-.61C276.29,187.55,275.41,186.82,275.49,186.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.84,
    y: 261.9,
    width: 10.43,
    height: 4.72,
    transform: "translate(-93.35 96.74) rotate(-24.4)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.77,264.25a11.2,11.2,0,0,1-.62-1.17c-.37-.73-.89-1.77-1.5-3l.25.09c-2.44,1.15-5.78,2.7-9.46,4.37-.12.31.15-.42.13-.34h0v0l0,0,0,.07.06.14.13.28.25.56c.17.37.33.73.5,1.09l.93,2.09-.33-.12c2.73-1.22,5.09-2.23,6.8-3l2-.84a5,5,0,0,1,.78-.29,3,3,0,0,1-.63.36l-1.91.94c-1.66.8-4,1.95-6.85,3.24l-.23.1-.1-.23c-.31-.66-.62-1.36-1-2.07-.17-.36-.33-.73-.5-1.1l-.25-.55-.13-.29-.07-.14,0-.07v-.05h0l.13-.34c3.69-1.68,7.05-3.17,9.53-4.24l.17-.08.08.17c.59,1.38,1.05,2.49,1.35,3.24A5.89,5.89,0,0,1,182.77,264.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.41,268.36a4.35,4.35,0,0,0,5.76,2.17l-3.6-7.93A4.34,4.34,0,0,0,168.41,268.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.41,268.36s-.12-.14-.26-.44a4.09,4.09,0,0,1-.27-1.42,4.34,4.34,0,0,1,.52-2.16,4.59,4.59,0,0,1,2.07-2l.22-.1.1.22c.57,1.23,1.18,2.56,1.82,4s1.22,2.73,1.78,4l.1.22-.22.1a4.52,4.52,0,0,1-2.84.26,4.28,4.28,0,0,1-2-1,3.9,3.9,0,0,1-.88-1.13c-.15-.31-.2-.48-.17-.49a7.9,7.9,0,0,0,1.23,1.4,4.26,4.26,0,0,0,4.43.55l-.12.32-1.82-4c-.62-1.4-1.22-2.73-1.78-4l.32.12a4.24,4.24,0,0,0-2.5,3.69A8.47,8.47,0,0,0,168.41,268.36Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.94,266.4a2.74,2.74,0,0,0-1.15,2.69",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.79,269.09c-.13.06-.44-.73-.06-1.61s1.16-1.21,1.21-1.08-.43.56-.73,1.28S168.94,269.06,168.79,269.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.79,268.1a9,9,0,0,1-1.14-2.19,9.38,9.38,0,0,1-1-2.27,7.13,7.13,0,0,1,2.14,4.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.9,267.6a9.58,9.58,0,0,1-1.14-2.2,9.79,9.79,0,0,1-1-2.26c.11-.09.86.77,1.46,2A4.5,4.5,0,0,1,175.9,267.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,267.09a9.19,9.19,0,0,1-1.14-2.19,9.38,9.38,0,0,1-1-2.27,7.13,7.13,0,0,1,2.14,4.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.13,266.59a9.85,9.85,0,0,1-1.14-2.2,9.57,9.57,0,0,1-1-2.27,4.67,4.67,0,0,1,1.46,2A4.53,4.53,0,0,1,178.13,266.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.25,266.08a9.14,9.14,0,0,1-1.14-2.2,9.4,9.4,0,0,1-1-2.26,7.13,7.13,0,0,1,2.14,4.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.36,265.57a9.37,9.37,0,0,1-1.14-2.19,9.57,9.57,0,0,1-1-2.27,4.67,4.67,0,0,1,1.46,2A4.52,4.52,0,0,1,180.36,265.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.48,265.07a40.24,40.24,0,0,1-2.14-4.46c.11-.09.87.77,1.47,2A4.61,4.61,0,0,1,181.48,265.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.52,142.38s12.11,12,15.13,19.43c2.87,7.11,4.77,13.73,4.77,13.73s3.12-5.46,6.63,0,20.1,71.77,22.83,96.73h10.57s-4.92-41.73-7.26-46.41-4.3-6.24-4.3-6.24-2.73-17.56-4.68-20.29a13.16,13.16,0,0,0-4.29-3.9s-3.51-19.11-8.58-23-9-1.95-9-1.95S220.14,150,201.52,142.38Z",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.67,231a55.81,55.81,0,0,0-7,2.38,58.26,58.26,0,0,0-6.41,3.72,6.81,6.81,0,0,1,1.62-1.48,24.09,24.09,0,0,1,9.62-4.37A7.24,7.24,0,0,1,300.67,231Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.26,228.86A72.81,72.81,0,0,0,293.2,232c-3.73,2.06-6.28,4.45-6.39,4.32a8.14,8.14,0,0,1,1.6-1.63,28,28,0,0,1,4.54-3.14,26.89,26.89,0,0,1,5.07-2.18A7.88,7.88,0,0,1,300.26,228.86Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.21,234c0,.16-2.2.19-4.79.94s-4.49,1.85-4.57,1.72a13.27,13.27,0,0,1,9.36-2.66Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.88,272.17c-1.77-14,2.83-30.42,14-38.28l2.66,2.17s-13.91,8.28-12.89,36.21",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.41,252a33.58,33.58,0,0,0-5.37,2.39,34.87,34.87,0,0,0-4.56,3.71,13.8,13.8,0,0,1,9.93-6.1Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.13,250.76a51.19,51.19,0,0,1-5.44,2.1,50.87,50.87,0,0,1-5.5,2,24.23,24.23,0,0,1,5.32-2.46A23.76,23.76,0,0,1,217.13,250.76Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.94,275.62l-4.84-1.26a10.74,10.74,0,0,0-3.65-11.13,9.21,9.21,0,0,1-5.31,7.13,7.86,7.86,0,0,1-6.65-.42,6.93,6.93,0,0,1-3.63-4.72,7.86,7.86,0,0,1,3.87-8,9.8,9.8,0,0,1,3.66-1.24,3.51,3.51,0,0,0-.36-.29,13.38,13.38,0,0,0-15.08-.41l-2.82-4.13a18.33,18.33,0,0,1,20.94.56,14.92,14.92,0,0,1,4.35,5.22,15.83,15.83,0,0,1,9.52,18.72ZM233,260.83a5.35,5.35,0,0,0-2.76.67,2.93,2.93,0,0,0-1.52,2.75,2.08,2.08,0,0,0,1.09,1.29,2.93,2.93,0,0,0,2.37.2,4.5,4.5,0,0,0,2.32-4.58l0-.2A8.44,8.44,0,0,0,233,260.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.34,182.76a7.84,7.84,0,0,1,1.34.71c.85.48,2,1.24,3.48,2.23a61.07,61.07,0,0,1,4.85,3.78,62,62,0,0,1,10.07,11.14,58.32,58.32,0,0,1,3.27,5.19c.85,1.53,1.49,2.79,1.88,3.69a7.7,7.7,0,0,1,.57,1.4,8,8,0,0,1-.75-1.31c-.45-.87-1.13-2.1-2-3.59s-2-3.24-3.34-5.11a67.21,67.21,0,0,0-10-11C215,188.33,213.35,187,212,186s-2.56-1.83-3.38-2.36A8.61,8.61,0,0,1,207.34,182.76Z",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.42,294.18h.85a0,0,0,0,1,0,0v50.51a0,0,0,0,1,0,0h-.85a9,9,0,0,1-9-9V303.14A9,9,0,0,1,190.42,294.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.87,294.18h.94a8.88,8.88,0,0,1,8.88,8.88v32.76a8.88,8.88,0,0,1-8.88,8.88h-.94a0,0,0,0,1,0,0V294.18A0,0,0,0,1,335.87,294.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 188.69,
    y: 284.32,
    width: 149.39,
    height: 109.99,
    rx: 14.12,
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.39,296a34.23,34.23,0,0,0-34.23,34.23h68.47A34.23,34.23,0,0,0,282.39,296Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,328.58c1.44,0,2.74,0,3.68,0a6.73,6.73,0,0,1,1.53.1,7.86,7.86,0,0,1-1.52.11c-1,0-2.25,0-3.69,0l-3.68,0-1.12,0a1.75,1.75,0,0,1-.41,0,1.26,1.26,0,0,1,.41,0l1.12-.05Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.58,318.23c2.6-1.24,4.76-2.11,4.83-2s-2,1.24-4.62,2.41a34.84,34.84,0,0,1-4.83,2A35,35,0,0,1,307.58,318.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.16,309.77c1.9-2.16,3.54-3.82,3.67-3.71s-1.35,1.93-3.29,4.05a33.89,33.89,0,0,1-3.67,3.7A34.86,34.86,0,0,1,301.16,309.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292,304.36a23,23,0,0,1,2.05-4.79c.16.06-.54,2.28-1.57,5a35.67,35.67,0,0,1-2.06,4.79A34.19,34.19,0,0,1,292,304.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.51,302.58c0-2.88.08-5.21.25-5.21s.28,2.33.26,5.21a33.85,33.85,0,0,1-.26,5.21A33.18,33.18,0,0,1,281.51,302.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.05,304.54c-1-2.69-1.74-4.91-1.58-5s1.08,2.08,2,4.79a32.38,32.38,0,0,1,1.58,5A34.94,34.94,0,0,1,271.05,304.54Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262,310.11c-1.94-2.12-3.42-3.93-3.29-4.05s1.77,1.55,3.67,3.71a34.86,34.86,0,0,1,3.29,4A33.89,33.89,0,0,1,262,310.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.73,318.7c-2.63-1.18-4.7-2.26-4.63-2.42s2.24.72,4.84,2a35.13,35.13,0,0,1,4.62,2.41A34.91,34.91,0,0,1,255.73,318.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.55,328.83c-1.44,0-2.74,0-3.69,0a7.86,7.86,0,0,1-1.52-.11,6.73,6.73,0,0,1,1.53-.1c.94,0,2.24,0,3.68,0l3.68.06,1.12.05a1.17,1.17,0,0,1,.4,0,1.6,1.6,0,0,1-.4,0l-1.12,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.31,302a4.55,4.55,0,1,1-4.55-4.54A4.55,4.55,0,0,1,225.31,302Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.31,315.7a4.55,4.55,0,1,1-4.55-4.54A4.55,4.55,0,0,1,225.31,315.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.43,384.82s0-.29,0-.85,0-1.39,0-2.45c0-2.17,0-5.33-.05-9.38,0-8.13-.06-19.85-.1-34.3l.19.19-93.17.07h0l.26-.26c0,16.57,0,32.46,0,47l-.25-.24,66.92.11,19.3.07,5.16,0,1.34,0h.46l-.43,0h-1.31l-5.11,0-19.25.07-67.08.12H218v-.25c0-14.52,0-30.41,0-47v-.26h.27l93.17.07h.2v.19c-.05,14.5-.08,26.26-.11,34.41,0,4,0,7.19,0,9.34,0,1.05,0,1.86,0,2.42S311.43,384.82,311.43,384.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.1,394.09H322.67a0,0,0,0,1,0,0v.59a6.23,6.23,0,0,1-6.23,6.23H210.34a6.23,6.23,0,0,1-6.23-6.23v-.59a0,0,0,0,1,0,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301.47,344.43a2.81,2.81,0,0,0,1.93,3,3.11,3.11,0,0,0,3.39-1.24,3.49,3.49,0,0,0,0-3.67,3.48,3.48,0,0,1-.78,2.35,2.56,2.56,0,0,1-2.26.88,2,2,0,0,1-1.69-1.64"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M306.81,343.32a2.77,2.77,0,1,1-2.76-2.76A2.76,2.76,0,0,1,306.81,343.32Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.81,343.32a5.24,5.24,0,0,1-.18-.65,2.78,2.78,0,0,0-1-1.4,2.61,2.61,0,0,0-2.42-.32,2.53,2.53,0,0,0,0,4.74,2.61,2.61,0,0,0,2.42-.32,2.78,2.78,0,0,0,1-1.4,6,6,0,0,1,.18-.65s.09.25,0,.7a2.7,2.7,0,0,1-1,1.64,2.92,2.92,0,0,1-2.81.48,3,3,0,0,1,0-5.64,2.92,2.92,0,0,1,2.81.48,2.7,2.7,0,0,1,1,1.64C306.9,343.07,306.84,343.32,306.81,343.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.32,342.14c.05.14-.6.48-1.21,1.12s-.93,1.29-1.07,1.24,0-.87.7-1.61S305.29,342,305.32,342.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.32,344.18c-.12.08-.58-.42-1.26-.87s-1.32-.7-1.29-.85.81-.11,1.58.42S305.44,344.12,305.32,344.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M302.76,378.63a2.83,2.83,0,0,0,1.94,3,3.11,3.11,0,0,0,3.39-1.24,3.49,3.49,0,0,0,.05-3.66,3.43,3.43,0,0,1-.79,2.34,2.55,2.55,0,0,1-2.25.88,2,2,0,0,1-1.7-1.63"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 305.35,
    cy: 377.51,
    r: 2.76,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.11,377.51c-.05,0-.06-.24-.19-.65a2.74,2.74,0,0,0-1-1.4,2.62,2.62,0,0,0-2.42-.32,2.54,2.54,0,1,0,2.42,4.42,2.7,2.7,0,0,0,1-1.4c.13-.4.14-.65.19-.65s.09.25,0,.7a2.74,2.74,0,0,1-1,1.65,2.93,2.93,0,0,1-2.81.47,3,3,0,0,1,0-5.64,3,3,0,0,1,2.81.48,2.7,2.7,0,0,1,1,1.64C308.2,377.27,308.14,377.52,308.11,377.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.62,376.33c.05.14-.61.48-1.21,1.12s-.93,1.29-1.08,1.25,0-.88.7-1.61S306.59,376.2,306.62,376.33Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.62,378.37c-.13.09-.59-.42-1.27-.87s-1.31-.7-1.28-.85.8-.11,1.58.42S306.74,378.31,306.62,378.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M222.38,344.39a2.83,2.83,0,0,0,1.94,3,3.12,3.12,0,0,0,3.39-1.25,3.49,3.49,0,0,0,0-3.66,3.45,3.45,0,0,1-.79,2.35,2.55,2.55,0,0,1-2.25.88,2,2,0,0,1-1.7-1.64"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 224.96,
    cy: 343.28,
    r: 2.76,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.73,343.28s-.06-.25-.19-.65a2.67,2.67,0,0,0-1-1.4,2.59,2.59,0,0,0-2.41-.32,2.53,2.53,0,0,0,0,4.74,2.62,2.62,0,0,0,2.42-.32,2.7,2.7,0,0,0,1-1.4c.13-.4.14-.65.19-.65a1.21,1.21,0,0,1,0,.7,2.75,2.75,0,0,1-1,1.64,2.93,2.93,0,0,1-2.81.48,3,3,0,0,1,0-5.64,2.93,2.93,0,0,1,2.81.48,2.75,2.75,0,0,1,1,1.64A1.21,1.21,0,0,1,227.73,343.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.24,342.1c0,.14-.61.48-1.21,1.12s-.93,1.29-1.08,1.24,0-.88.7-1.61S226.21,342,226.24,342.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.24,344.14c-.13.08-.59-.42-1.27-.87s-1.31-.7-1.28-.85.8-.11,1.58.41S226.36,344.07,226.24,344.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M221.8,378.29a2.8,2.8,0,0,0,1.93,3,3.11,3.11,0,0,0,3.39-1.24,3.47,3.47,0,0,0,0-3.66,3.47,3.47,0,0,1-.78,2.34,2.57,2.57,0,0,1-2.26.89,2,2,0,0,1-1.69-1.64"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 224.38,
    cy: 377.17,
    r: 2.76,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.14,377.17s0-.24-.18-.65a2.87,2.87,0,0,0-1-1.4,2.61,2.61,0,0,0-2.42-.32,2.54,2.54,0,1,0,2.42,4.42,2.78,2.78,0,0,0,1-1.4,6,6,0,0,1,.18-.65s.09.25,0,.7a2.72,2.72,0,0,1-1,1.65,3,3,0,0,1-2.81.48,3,3,0,0,1,0-5.65,3,3,0,0,1,2.81.48,2.72,2.72,0,0,1,1,1.65C227.23,376.93,227.17,377.18,227.14,377.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.65,376c0,.14-.6.48-1.21,1.12s-.93,1.29-1.07,1.25,0-.88.7-1.61S225.62,375.86,225.65,376Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.65,378c-.12.08-.58-.43-1.26-.88s-1.32-.7-1.29-.85.81-.11,1.58.42S225.77,378,225.65,378Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M218.25,385.08c10.82,2.35,23.46,2.44,35.15,1.87,5.62-.28,11.79-.63,16.29,2.76,1,.74,2.14,1.71,3.3,1.28,1.68-.63,1.74-3.71,3.54-3.77.9,0,1.59.83,1.88,1.68a13,13,0,0,0,.82,2.56c.46.78,1.55,1.3,2.27.75,1.14-.87-.18-2.74.25-4.11s2.47-1.53,3.85-1,2.72,1.54,4.19,1.32a8.19,8.19,0,0,0,2.83-1.45c2.63-1.61,5.88-1.7,9-1.76,3.25-.05,6.6-.36,9.85-.42Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M292.77,349.79a2.22,2.22,0,0,1-.51.18,11.73,11.73,0,0,0-1.45.49,22,22,0,0,0-4.88,2.76c-1.95,1.36-4.1,3.24-6.83,4.9a15.6,15.6,0,0,1-4.63,1.93,26.2,26.2,0,0,1-5.34.4c-3.65,0-6.84,1.48-9.6,3s-5.29,2.84-7.26,4.17a26.22,26.22,0,0,0-4.34,3.56c-.93,1-1.36,1.55-1.4,1.52s.08-.16.28-.45a14,14,0,0,1,1-1.21,23.79,23.79,0,0,1,4.28-3.72,78,78,0,0,1,7.24-4.3,33.09,33.09,0,0,1,4.52-2.1,15.5,15.5,0,0,1,5.29-.95,26.23,26.23,0,0,0,5.25-.38,15.77,15.77,0,0,0,4.5-1.84c2.68-1.61,4.87-3.46,6.86-4.79a20.61,20.61,0,0,1,5-2.65,8.71,8.71,0,0,1,1.49-.4A2,2,0,0,1,292.77,349.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.06,357.71a13,13,0,0,1-2.9-.45,43.59,43.59,0,0,1-6.77-2.1,42.76,42.76,0,0,1-6.34-3.16,12.39,12.39,0,0,1-2.41-1.69,25.49,25.49,0,0,1,2.59,1.37,59.77,59.77,0,0,0,13,5.23A21,21,0,0,1,269.06,357.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.1,325.07c.77-.41,23.24-7.64,23.24-7.64l-21.48,12Z",
    style: {
      fill: "#769A93"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.76,322.64a7.6,7.6,0,0,0-7.6,7.6h15.2A7.6,7.6,0,0,0,281.76,322.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.35,394.09c-.15,0-.26-24.42-.26-54.54s.11-54.55.26-54.55.26,24.42.26,54.55S205.49,394.09,205.35,394.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.2,394.09c-.15,0-.26-24.42-.26-54.54s.11-54.55.26-54.55.26,24.42.26,54.55S324.34,394.09,324.2,394.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.36,
    cy: 298.63,
    r: 1.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.36,
    cy: 320.51,
    r: 1.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.36,
    cy: 342.4,
    r: 1.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.36,
    cy: 364.29,
    r: 1.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 200.36,
    cy: 386.17,
    r: 1.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.31,
    cy: 298.63,
    r: 1.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.31,
    cy: 320.51,
    r: 1.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.31,
    cy: 342.4,
    r: 1.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.31,
    cy: 364.29,
    r: 1.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 330.31,
    cy: 386.17,
    r: 1.17,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.3,
    y: 272.27,
    width: 51.1,
    height: 12.04,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238,284.32a32.12,32.12,0,0,1-.26-5.82,32,32,0,0,1,.26-5.81,33.09,33.09,0,0,1,.26,5.81A33.25,33.25,0,0,1,238,284.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.23,284.32a33.25,33.25,0,0,1-.26-5.82,33.09,33.09,0,0,1,.26-5.81,32,32,0,0,1,.26,5.81A32.12,32.12,0,0,1,243.23,284.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.48,284.32a33.25,33.25,0,0,1-.26-5.82,33.09,33.09,0,0,1,.26-5.81,33.09,33.09,0,0,1,.26,5.81A33.25,33.25,0,0,1,248.48,284.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.73,284.32a32.12,32.12,0,0,1-.26-5.82,32,32,0,0,1,.26-5.81,33.09,33.09,0,0,1,.26,5.81A33.25,33.25,0,0,1,253.73,284.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259,284.32a33.25,33.25,0,0,1-.26-5.82,33.09,33.09,0,0,1,.26-5.81,32,32,0,0,1,.26,5.81A32.12,32.12,0,0,1,259,284.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.22,284.32a33.25,33.25,0,0,1-.26-5.82,33.09,33.09,0,0,1,.26-5.81,33.09,33.09,0,0,1,.26,5.81A33.25,33.25,0,0,1,264.22,284.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.47,284.32a32.12,32.12,0,0,1-.26-5.82,32,32,0,0,1,.26-5.81,33.09,33.09,0,0,1,.26,5.81A33.25,33.25,0,0,1,269.47,284.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.71,284.32a33.25,33.25,0,0,1-.26-5.82,33.09,33.09,0,0,1,.26-5.81,32,32,0,0,1,.26,5.81A32.12,32.12,0,0,1,274.71,284.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,284.32a33.25,33.25,0,0,1-.26-5.82,33.09,33.09,0,0,1,.26-5.81,33.09,33.09,0,0,1,.26,5.81A33.25,33.25,0,0,1,280,284.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M345.68,310.42c1.24,6.26,2.39,12.16,3.62,18.42a26.7,26.7,0,0,1-3.62,0c0-6,0-12.41,0-18.41"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M192.15,296.05c.14,0,0,18.68-.35,41.71s-.71,41.7-.86,41.7,0-18.67.34-41.71S192,296.05,192.15,296.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.89,382c-.15,0-.26-9.3-.26-20.77s.11-20.77.26-20.77.26,9.3.26,20.77S214,382,213.89,382Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.1,287.68c0,.15-22.93.26-51.2.26s-51.2-.11-51.2-.26,22.92-.26,51.2-.26S312.1,287.54,312.1,287.68Z",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeoutImg);
export default __webpack_public_path__ + "static/media/timeout_img.6b81b325f1d9d2c3682d4dc7baea48a1.svg";
export { ForwardRef as ReactComponent };